import { CloseModalButton } from '@library/components/buttons';

interface RankDrawerHeaderProps {
  onCancelModal: () => void;
}

export const RankDrawerHeader = ({ onCancelModal }: RankDrawerHeaderProps) => (
  <div className="border-soFresh-140 text-soClean-100 flex h-[72px] items-center border-b pl-6 text-lg font-bold">
    <span>Global Rank</span>
    <CloseModalButton handleOnClick={onCancelModal} />
  </div>
);
